import Vue from 'vue';

import { motherRussiaNumbers, motherRussiaDateTime } from 'RootDir/common/helpers';

const prettyNumber = (n: number): string => motherRussiaNumbers.format(n);

const prettyDateTime = (n: string| Date): string => {
  if (n instanceof Date) {
    return n.toLocaleString('ru-Ru');
    // return motherRussiaDateTime.format(n);
  }

  try {
    const d = new Date(n);
    return d.toLocaleString('ru-Ru');
    // return motherRussiaDateTime.format(d);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`Невозможно пивести переменную "${n}" к типу Date`);
  }
  return n;
};

export const filters = {
  prettyNumber,
  prettyDateTime,
};

export default (vue): void => {
  Object.entries(filters).forEach(([key, filter]) => {
    vue.filter(key, filter);
  });
};
